module.exports = __webpack_public_path__ + "img/fart-cloud-1.a93ee4d8.png";